// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/backshape.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Capibilities_capabilities__0j\\+s- {
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover; /* Ensure the image covers the entire section */
  background-repeat: no-repeat;
  background-size: 1170px;
  margin-bottom: 2.7rem;
  /* background-color: black; */
}
.Capibilities_head__Z9xjI {
  color: #ff6500;
  font-family: Poppins;
  font-size: 16px;
  padding-top: 6rem;
  /* margin-top: 5rem; */
}
.Capibilities_cardDiv__DvtG7 {
  /* padding-bottom: 1rem; */
  border-top: 1px solid;
  /* background-color: black; */
  border-image-source: linear-gradient(
    270deg,
    rgba(152, 162, 179, 0) 0%,
    rgba(152, 162, 179, 0.7) 34.18%,
    rgba(152, 162, 179, 0.7) 66.81%,
    rgba(152, 162, 179, 0) 100%
  );
  border-image-slice: 1;
  /* background-color: pink; */
}
.Capibilities_para__S8XZ8 {
  font-family: Poppins;
  font-weight: 500;
  font-size: 34px;

  margin-bottom: 2rem;
}
.Capibilities_highlight__mHb\\+s {
  color: #ff6500;
}
.Capibilities_cardHeading__MIZFo {
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600px;
}
.Capibilities_cardInfo__ig97Z {
  font-family: Poppins;
  color: #667085;
  font-size: 16px;

  margin-bottom: 2rem;
  border-bottom: 1px solid;
  /* border: 1px solid; */
  padding-bottom: 1rem;

  border-image-source: linear-gradient(
    270deg,
    rgba(152, 162, 179, 0) 0%,
    rgba(152, 162, 179, 0.7) 34.18%,
    rgba(152, 162, 179, 0.7) 66.81%,
    rgba(152, 162, 179, 0) 100%
  );
  border-image-slice: 1;
}
.Capibilities_image__QTJeY {
  margin-bottom: 1.5rem;
  margin-top: 1.7rem;
}
.Capibilities_border__ymaqa {
  border-right: 1px solid;
  border-image-source: linear-gradient(
    rgba(152, 162, 179, 0) 0%,
    rgba(152, 162, 179, 0.7) 34.18%,
    rgba(152, 162, 179, 0.7) 66.81%,
    rgba(152, 162, 179, 0) 100%
  );
  border-image-slice: 1;
  /* height: 150%;  */
}
@media (min-width: 300px) and (max-width: 400px) {
  .Capibilities_capabilities__0j\\+s- {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    width: 377px;
    align-items: center;
    margin-bottom: 2.7rem;
  }
  .Capibilities_para__S8XZ8 {
    font-family: Poppins;
    font-weight: 500;
    font-size: 34px;

    margin-bottom: 2rem;
    padding-right: 3px;
  }

}
@media (min-width: 400px) and (max-width: 568px) {
  .Capibilities_capabilities__0j\\+s- {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    width: 436px;
    align-items: center;
    margin-bottom: 2.7rem;
  }
  .Capibilities_para__S8XZ8 {
    font-family: Poppins;
    font-weight: 500;
    font-size: 34px;

    margin-bottom: 2rem;
    padding-right: 3px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Capibilities.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yDAAgD;EAChD,sBAAsB,EAAE,+CAA+C;EACvE,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B;;;;;;GAMC;EACD,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;;EAEf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;;EAEf,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;;EAEpB;;;;;;GAMC;EACD,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB;;;;;GAKC;EACD,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE;IACE,yDAAgD;IAChD,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;;IAEf,mBAAmB;IACnB,kBAAkB;EACpB;;AAEF;AACA;EACE;IACE,yDAAgD;IAChD,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;;IAEf,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".capabilities {\n  text-align: center;\n  background-image: url(\"../images/backshape.svg\");\n  background-size: cover; /* Ensure the image covers the entire section */\n  background-repeat: no-repeat;\n  background-size: 1170px;\n  margin-bottom: 2.7rem;\n  /* background-color: black; */\n}\n.head {\n  color: #ff6500;\n  font-family: Poppins;\n  font-size: 16px;\n  padding-top: 6rem;\n  /* margin-top: 5rem; */\n}\n.cardDiv {\n  /* padding-bottom: 1rem; */\n  border-top: 1px solid;\n  /* background-color: black; */\n  border-image-source: linear-gradient(\n    270deg,\n    rgba(152, 162, 179, 0) 0%,\n    rgba(152, 162, 179, 0.7) 34.18%,\n    rgba(152, 162, 179, 0.7) 66.81%,\n    rgba(152, 162, 179, 0) 100%\n  );\n  border-image-slice: 1;\n  /* background-color: pink; */\n}\n.para {\n  font-family: Poppins;\n  font-weight: 500;\n  font-size: 34px;\n\n  margin-bottom: 2rem;\n}\n.highlight {\n  color: #ff6500;\n}\n.cardHeading {\n  font-family: Poppins;\n  font-size: 20px;\n  font-weight: 600px;\n}\n.cardInfo {\n  font-family: Poppins;\n  color: #667085;\n  font-size: 16px;\n\n  margin-bottom: 2rem;\n  border-bottom: 1px solid;\n  /* border: 1px solid; */\n  padding-bottom: 1rem;\n\n  border-image-source: linear-gradient(\n    270deg,\n    rgba(152, 162, 179, 0) 0%,\n    rgba(152, 162, 179, 0.7) 34.18%,\n    rgba(152, 162, 179, 0.7) 66.81%,\n    rgba(152, 162, 179, 0) 100%\n  );\n  border-image-slice: 1;\n}\n.image {\n  margin-bottom: 1.5rem;\n  margin-top: 1.7rem;\n}\n.border {\n  border-right: 1px solid;\n  border-image-source: linear-gradient(\n    rgba(152, 162, 179, 0) 0%,\n    rgba(152, 162, 179, 0.7) 34.18%,\n    rgba(152, 162, 179, 0.7) 66.81%,\n    rgba(152, 162, 179, 0) 100%\n  );\n  border-image-slice: 1;\n  /* height: 150%;  */\n}\n@media (min-width: 300px) and (max-width: 400px) {\n  .capabilities {\n    background-image: url(\"../images/backshape.svg\");\n    background-size: cover;\n    width: 377px;\n    align-items: center;\n    margin-bottom: 2.7rem;\n  }\n  .para {\n    font-family: Poppins;\n    font-weight: 500;\n    font-size: 34px;\n\n    margin-bottom: 2rem;\n    padding-right: 3px;\n  }\n\n}\n@media (min-width: 400px) and (max-width: 568px) {\n  .capabilities {\n    background-image: url(\"../images/backshape.svg\");\n    background-size: cover;\n    width: 436px;\n    align-items: center;\n    margin-bottom: 2.7rem;\n  }\n  .para {\n    font-family: Poppins;\n    font-weight: 500;\n    font-size: 34px;\n\n    margin-bottom: 2rem;\n    padding-right: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"capabilities": `Capibilities_capabilities__0j+s-`,
	"head": `Capibilities_head__Z9xjI`,
	"cardDiv": `Capibilities_cardDiv__DvtG7`,
	"para": `Capibilities_para__S8XZ8`,
	"highlight": `Capibilities_highlight__mHb+s`,
	"cardHeading": `Capibilities_cardHeading__MIZFo`,
	"cardInfo": `Capibilities_cardInfo__ig97Z`,
	"image": `Capibilities_image__QTJeY`,
	"border": `Capibilities_border__ymaqa`
};
export default ___CSS_LOADER_EXPORT___;
